import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import {
  apiGetProjectNewAddHasEquity,
  apiGetSkuByBenefitCode,
  apiGetEquityNum,
  apiSubProjectEquityNum,
} from '../api';
import { UserContext } from 'libs/contexts';
import { Modal } from 'antd';

const { confirm } = Modal;
const benefitCode = 'NEW_PROJECT_QUERY';
// isListPage 页面是否需要权限访问，需要权限访问的页面在无权限是弹窗提示购买
export default function useProjectNewAddData(isListPage = false) {
  // 是否购买过权益
  const [hasEquity, setHasEquity] = useState(false);
  const [equityLoading, setEequityLoading] = useState(true);
  // 权益商品id
  const [skuId, setSkuId] = useState('');
  const [equityNum, setEquityNum] = useState(0);
  const router = useRouter();
  const userInfo = useContext(UserContext);

  const queryHasEquityAndGetSkuId = async () => {
    try {
      if (!userInfo?.isSupplier || !userInfo?.supplierSysNo) {
        setEequityLoading(false);
        return;
      }
      const { data } = await apiGetProjectNewAddHasEquity();
      setHasEquity(data);
      setEequityLoading(false);
      if (!data) {
        const res = await apiGetSkuByBenefitCode({
          benefitCode,
        });
        if (res.code === 200) {
          setSkuId(res.data?.skuSysNoList?.[0]);
        }
        if (isListPage) {
          toBuyConfirm();
        }
      }
    } catch (err) {}
    setEequityLoading(false);
  };

  const queryEquityNum = async () => {
    try {
      if (!userInfo?.supplierSysNo) return;
      const { data, code } = await apiGetEquityNum({
        supplierSysNo: userInfo?.supplierSysNo,
        benefitCode,
      });
      if (code !== 200) return;
      setEquityNum(data?.remainingUses || 0);
    } catch (error) {}
  };

  const subProjectEquityNum = async (id, callback) => {
    try {
      const { code } = await apiSubProjectEquityNum({
        id,
      });
      if (code !== 200) return;
      callback();
    } catch (error) {}
  };

  useEffect(() => {
    queryHasEquityAndGetSkuId();
    queryEquityNum();
  }, []);
  const toBuyConfirm = (content = '尚未购买权益，仅支持查看列表!', okText = '去购买') => {
    confirm({
      title: '温馨提示',
      content,
      okText,
      icon: null,
      onOk() {
        router.push(skuId ? `/pages/extra-serve/${skuId}` : '/pages/extra-serve');
      },
    });
  };

  // 首页点击更多
  const homeClickMore = async (callback) => {
    try {
      let bol = hasEquity;
      // 如果没有权限再查一次
      if (!hasEquity) {
        const { data } = await apiGetProjectNewAddHasEquity();
        setHasEquity(data);
        bol = data;
      }
      if (bol) {
        callback && callback();
      } else {
        toBuyConfirm();
      }
    } catch (err) {}
  };

  // 首页项目列表
  const buildHomeProjectList = (data, max = 4) => {
    if (!data?.length) return data;
    const list = [...data];
    for (let index = data.length; index < max; index++) {
      list.push({
        _isFill: true,
      });
    }
    return list.slice(0, max);
  };
  const handleToDetail = (row, callback) => {
    // 0 未购买 1已购买
    if (row.buyFlag === 1 || equityNum === -1) {
      callback && callback();
    } else if (equityNum > 0) {
      confirm({
        title: '温馨提示',
        content: '是否使用1条权益数查看该详情？',
        icon: null,
        onOk() {
          subProjectEquityNum(row.id, callback);
        },
      });
    } else {
      toBuyConfirm('您当前权益已使用完毕，建议再次购买！', '再次购买');
    }
  };
  return {
    hasEquity, // 是否有权益
    buildHomeProjectList, // 首页列表数据拼接
    homeClickMore, // 首页点击更多校验
    handleToDetail, // 列表查看详情校验
    equityNum, // 权益数量
    equityLoading,
  };
}
